import { Modal } from 'react-responsive-modal';
import { Form, FormContainer, FormWrapper } from './components';
import { StyledInput } from '../../../../components/StyledInput';
import { StyledSelect } from '../../../UserVehicles/components/StyledSelect';
import { useEffect, useState } from 'react';
import { UF } from '../../../../utils/enums';
import './modal.scss';
import { debtTypeOptions, statusOptions } from '../..';
import { StyledDateInput } from '../../../../components/StyledDateInput';
import { getEnumKeyByValue } from '../../../../utils/ufsNamed';

export interface ISelectOptions {
  value: string;
  label: string;
}

export interface IHandleApplyFiltersProps {
  plate: string | undefined;
  conductor: string | undefined;
  uf: string | undefined;
  debtType: ISelectOptions | undefined;
  initialDate: Date | undefined;
  endDate: Date | undefined;
  parcelaIpva: string | undefined;
  endPlate: string | undefined;
  status: ISelectOptions | undefined;
  isUniqueInstallments?: boolean;
}

export interface IGlobalFiltersModalProps {
  open: boolean;
  setOpen: (item: boolean) => void;
  plateTable?: string;
  ufTable?: { value: string; label: string } | undefined;
  statusTable?: ISelectOptions;
  debtTypeTable?: ISelectOptions;
  handleApplyFilters: (props: IHandleApplyFiltersProps) => Promise<void>;

}

export default function AdvancedFiltersModal({ open, setOpen, plateTable, ufTable, statusTable, debtTypeTable, handleApplyFilters }: IGlobalFiltersModalProps) {
  const [debtTypeToShow, setDebtTypeToShow] = useState<string | undefined>();
  const [statusToShow, setStatusToShow] = useState<string | undefined>();
  const [conductor, setConductor] = useState<string | undefined>();
  const [plate, setPlate] = useState<string | undefined>();
  const [uf, setUf] = useState<string | undefined>();
  const [debtType, setDebtType] = useState<ISelectOptions | undefined>();
  const [initialDate, setInitialDate] = useState<Date | undefined>();
  const [endDate, setEndDate] = useState<Date | undefined>();
  const [installmentSelected, setInstallmentSelected] = useState<string | undefined>();
  const [isUniqueInstallments, setIsUniqueInstallments] = useState<boolean | undefined>();
  const [parcelaIpva, setParcelaIpva] = useState<string | undefined>();
  const [endPlate, setEndPlate] = useState<string | undefined>();
  const [status, setStatus] = useState<ISelectOptions | undefined>();

  const parcelaIpvaOptions = ["cota", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  const endPlateOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]

  useEffect(() => {
    setUf(ufTable?.label)
    setPlate(plateTable)
    setStatusToShow(statusTable?.label)
    setStatus(statusTable)
    setDebtTypeToShow(debtTypeTable?.label)
    setDebtType(debtTypeTable)
  }, [plateTable, statusTable, debtTypeTable, ufTable])

  useEffect(() => {
    if (!installmentSelected || !(installmentSelected?.length > 0)) {
      setIsUniqueInstallments(undefined)
      setParcelaIpva("")
    } else {
      if (installmentSelected === "cota") {
        setIsUniqueInstallments(true)
        setParcelaIpva("")
      } else {
        setIsUniqueInstallments(false)
        setParcelaIpva(installmentSelected)
      }
    }
  }, [installmentSelected])

  function handleCleanFilters() {
    setConductor("")
    setPlate("")
    setUf("")
    setDebtTypeToShow("")
    setDebtType(undefined)
    setInitialDate(undefined)
    setEndDate(undefined)
    setInstallmentSelected("")
    setStatusToShow("")
    setStatus(undefined)
    setEndPlate("")
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      showCloseIcon={false}
      center
    >
      <div className='advanced-filters-modal-body'>
        <span className='title'>Filtros Avançados</span>

        <FormContainer>
          <Form>
            <FormWrapper>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledInput
                  style={{ gridColumn: 'span 2' }}
                  placeholder="Digite a placa"
                  value={plate}
                  maxLength={7}
                  onChange={(e) => setPlate(e.target.value)}
                  disabled={false}
                  labelTxt='Placa'
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledInput
                  style={{ gridColumn: 'span 2' }}
                  placeholder="Digite o condutor"
                  value={conductor}
                  maxLength={50}
                  onChange={(e) => setConductor(e.target.value)}
                  disabled={false}
                  labelTxt='Condutor'
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='UF'
                  placeholder="Selecione a UF"
                  value={uf}
                  setValue={setUf}
                  options={Object.keys(UF).map((key) => ({
                    id: UF[key as keyof typeof UF],
                    value: UF[key as keyof typeof UF],
                  }))}
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='Tipo de Débito'
                  placeholder="Selecione o débito"
                  value={debtTypeToShow}
                  setValue={val => {
                    debtTypeOptions.forEach(dType => {
                      if (dType.label === val) {
                        setDebtType(dType)
                      }
                    })
                    setDebtTypeToShow(val)
                  }}
                  options={debtTypeOptions.map((key) => ({
                    id: key.value,
                    value: key.label,
                  }))}
                />
              </label>
              <label htmlFor="">
                <StyledDateInput
                  labelTxt='Vencimento'
                  placeholder="Data de início"
                  value={initialDate}
                  onChange={setInitialDate}
                />

              </label>
              <label htmlFor="" style={{ marginTop: "20px" }}>
                <StyledDateInput
                  placeholder="Data de fim"
                  value={endDate}
                  onChange={setEndDate}
                  minDate={initialDate}
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='Parcela IPVA'
                  placeholder="Selecione a parcela"
                  value={installmentSelected}
                  setValue={setInstallmentSelected}
                  isShowOptId
                  options={parcelaIpvaOptions.map((key) => key === "cota"
                    ? ({
                      id: "cota única",
                      value: key
                    })
                    : ({
                      id: key,
                      value: key.toString(),
                    }))}
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='Final de Placa'
                  placeholder="Selecione"
                  value={endPlate}
                  setValue={setEndPlate}
                  options={endPlateOptions.map((key) => ({
                    id: key,
                    value: key.toString(),
                  }))}
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='Status'
                  placeholder="Selecione o status"
                  value={statusToShow}
                  setValue={val => {
                    statusOptions.forEach(sType => {
                      if (sType.label === val) {
                        setStatus(sType)
                      }
                    })
                    setStatusToShow(val)
                  }}
                  options={statusOptions.map((key) => ({
                    id: key.value,
                    value: key.label,
                  }))}
                />
              </label>
            </FormWrapper>
          </Form>
        </FormContainer>

        <span className='clean-form' onClick={handleCleanFilters}>Limpar todos os filtros</span>

        <div className='actions-buttons'>
          <button
            className='cancel'
            onClick={() => setOpen(false)}
          >
            Voltar
          </button>
          <button
            className='save'
            onClick={async () => {
              await handleApplyFilters({
                plate,
                conductor,
                uf,
                debtType,
                initialDate,
                endDate,
                parcelaIpva,
                isUniqueInstallments,
                endPlate,
                status
              })

              setOpen(false)
            }}
          >
            Aplicar
          </button>
        </div>
      </div>
    </Modal>
  )
}